import React from 'react';
import styles from './Loader.module.scss';
import { Spin } from 'antd';

export default function Loader() {
  return (
    <div className={styles.loader}>
      <Spin />
    </div>
  );
}
